// function to act as a class
function SelectCellEditor() { }

var KEY_ENTER = 13;

//
// Gets called once before the editor is used
//
SelectCellEditor.prototype.init = function (params) {

    var selectBox = this.selectBox = $(`<select data-container='body' data-none-selected-text='&nbsp;' data-select-on-tab='true' ${(params.liveSearch ? "data-live-search='true'" : "")}  />`);

    // Store if the user started the editing in this cell and we are directed to open the editor (we stuff "openEditor" into the keyPress b\c there's no other way for the grid
    // to pass custom info into here)
    this.openEditor = params.cellStartedEdit && params.keyPress != null && params.keyPress.openEditor == true;
    this.cellStartedEdit = params.cellStartedEdit

    // "items" comes from the AgJsonProperty in GridSelectEditorParameters
    var items = params.items;

    var nameValueHelper = rs.module("controls/framework/ag/agNameValueHelper");

    // Get the current value out of the row array.  This may be different that params.value b\c params.value is the result of the getValue
    // call, which for enums\codeValues would just be the name - we need all the data.
    var current = params.data[params.colDef.field];
    var selectedValue = nameValueHelper.isNameValue(current) ? nameValueHelper.getValue(current) : params.value;

    var itemsExist = items.length > 0;

    // "addEmptyOption" comes from the AgJsonProperty in GridSelectEditorParameters
    if (itemsExist && params.addEmptyOption) {
        selectBox.append($("<option></option>"));
    }

    // Fill in the provided values
    var selectedIndex = itemsExist ? 0 : -1;
    items.forEach(function (item, index) {

        var text = item.text;
        var value = item.value;


        var option = $("<option></option>",

            { text: text })

            // Store the value using jquery - storing it using option.value causes it to be converted to string
            .data("value", value);

        // If there is a custom renderer, do the rendering as the display
        if (params.cellRenderer) {
            option.attr("data-content", params.cellRenderer({ value, column: params.column }));
        }

        // Add the option to the box
        selectBox.append(option);

        // If this is a name\value, we need to compare the actual underlying int value, not the array that holds the name\value data
        var comparisonValue = nameValueHelper.isNameValue(value) ? nameValueHelper.getValue(value) : value

        if (selectedValue === comparisonValue) {
            selectedIndex = params.addEmptyOption ? (index + 1) : index;
        }
    });

    if (selectedIndex >= 0) {
        selectBox.find("option").eq(selectedIndex).prop("selected", true);
    }

    // Keep track of if the select is dropped down or not.
    selectBox.on('shown.bs.select', function () { this.shown = true }.bind(this));
    selectBox.on('hidden.bs.select', function () { this.shown = false }.bind(this));
};

//
// Gets called once when the grid is ready to insert the element
//
SelectCellEditor.prototype.getGui = function () {

    return this.selectBox[0];
};

//
// Editor initially created and attached
//
SelectCellEditor.prototype.afterGuiAttached = function () {

    this.selectBox.selectpicker();

    setTimeout(function () {

        if (this.openEditor) {
            this.selectBox.selectpicker("toggle");
        }
        else if (this.cellStartedEdit) {
            this.focusIn();
        }

    }.bind(this), 0);
};

//
// Tabbing into the cell
//
SelectCellEditor.prototype.focusIn = function () {

    this.selectBox.parent().find("button").focus();
};

//
// Tabbing out of the cell
//
SelectCellEditor.prototype.focusOut = function () {

    if (this.shown) {
        this.selectBox.selectpicker("toggle");
    }

};

//
// Destroying the editor
//
SelectCellEditor.prototype.destroy = function () {

    if (this.shown) {
        this.selectBox.selectpicker("toggle");
    }

};

//
// Returns the new value after editing
//
SelectCellEditor.prototype.getValue = function () {

    return this.selectBox.find(":selected").data("value");

};